var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2efea;}.cls-2{fill:none;stroke:#bfc0c0;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-3{fill:#e2062c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.5,
    cy: 26.5,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.5,
    cy: 26.5,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.46,24.11,27.6,36a1.55,1.55,0,0,1-2.2,0L13.54,24.11a1.57,1.57,0,0,1,1.11-2.67h23.7A1.57,1.57,0,0,1,39.46,24.11Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowCircle);
export default __webpack_public_path__ + "static/media/downArrowCircle.87e4db007bcd6cad19bca2fdf4281e30.svg";
export { ForwardRef as ReactComponent };